export const API_URL="https://apiv2.koehlerinstrument.interconnecta.dev";
export const API_KEY="123456789";
